import { useState } from "react";
import { Button, CircularProgress } from "../../../../components";
import { PermisoesHelper, responseStreamHelper } from "../../../../helpers";
import {
  NfEntradaService,
  notification,
  SessionService,
} from "../../../../services";
import {
  emitirRelatorioPrecificacao,
  podeEmitirRelatorioPrecificacao,
} from "../add-nf-entrada";

const nfEntradaService = new NfEntradaService();

const ButtonMenu = ({ id, nfEntrada }) => {
  const permissoesHelper = new PermisoesHelper();
  const sessionService = new SessionService();
  const [loading, setLoading] = useState(false);
  const nfEntradaId = nfEntrada?.id ?? id;
  const mostrarRelatorioPrecificacao = podeEmitirRelatorioPrecificacao(
    nfEntradaId,
    permissoesHelper.temPermisao("nf-entrada-visualizar"),
  );

  async function onClickRelatorioPrecificacao() {
    if (loading) return;
    setLoading(true);
    await emitirRelatorioPrecificacao(
      { nfEntradaId, empresa: sessionService.getEmpresaRelatorio() },
      {
        buscarRelatorio: (body) =>
          nfEntradaService.getRelatorioPrecificacao(body),
        gerarBlob: (result) => responseStreamHelper.getBlobPdf(result),
        abrirRelatorio: abrirAbaRelatorio,
        notification,
      },
    );
    setLoading(false);
  }

  function abrirAbaRelatorio(blob) {
    const url = URL.createObjectURL(blob);
    const pdfWindow = window.open(url, "_blank");
    if (!pdfWindow) {
      notification.alertaGenericos(
        "Popup bloqueado - por favor permita popups para este site",
      );
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  }

  return (
    <div className="d-flex align-items-center justify-content-center">
      {mostrarRelatorioPrecificacao && (
        <Button
          id="relatorioPrecificacaoButton"
          className="my-3 mx-2"
          variant="outlined"
          color="primary"
          size="small"
          disabled={loading}
          startIcon={
            loading ? <CircularProgress color="inherit" size={16} /> : null
          }
          onClick={onClickRelatorioPrecificacao}
        >
          Relatório Precificação
        </Button>
      )}
    </div>
  );
};

export default ButtonMenu;
